let tabs = document.querySelectorAll('.contacts-tabs .tab')

if(tabs.length) {
    let contacts = document.querySelectorAll('.contacts-wrapper')

    for(let tab of tabs) {
        tab.addEventListener('click', () => {
            let {type} = tab.dataset
            let siblings = tab.siblings()

            tab.classList.add('active')

            for(let sibling of siblings) {
                sibling.classList.remove('active')
            }

            for(let item of contacts) {
                if(item.dataset.type == type) {
                    item.classList.add('show')
                } else {
                    item.classList.remove('show')
                }
            }
        })
    }
}